import React, { useState } from "react";
import { BackgroundImage } from "../../ThirdComponents";
import { Button, Form, Input } from 'antd';
import { GoMail } from "react-icons/go";
import { FiPhoneCall } from "react-icons/fi";
import { FaCity } from "react-icons/fa";
import { MdApartment } from "react-icons/md";
import { Map } from "../../Components";
import axios from 'axios';
import { POST } from '../../utils/apis';
import { errorMessage, successMessage } from '../../utils/helpers';

const ThirdContact = (props) => {
    const { selectedLanguage } = props
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)

    const onFinish = (values) => {
        setLoading(true)
        values.designName = 'clinic-design-3'
        axios.post(POST?.CREATE_CONTACT_FORM, values)
            .then((res) => {
                const { data } = res
                setLoading(false)
                form.resetFields()
                if (data?.success) {
                    successMessage(data?.message)
                } else {
                    errorMessage(data?.message)
                }
            })
            .catch((e) => {
                setLoading(false)
                form.resetFields()
                errorMessage(e?.message)
            })
    }

    return (
        <div>
            <BackgroundImage {...props} heading={selectedLanguage?.txt_contact_} mainClass='third-design-contact-banner' />
            <div className="third-design-appointment-container third-design-contact-screen-container">
                <div className="third-design-appointment-text-div third-design-appointment-screen-text-div">
                    <h2 className="third-design-heading-1" data-aos="fade-right"
                        data-aos-easing="ease-out-cubic"
                        data-aos-delay="100"
                        data-aos-offset="0"
                        data-aos-duration="1500">{selectedLanguage?.txt_contact_}</h2>
                    <h1 className="third-design-heading-2">{selectedLanguage?.txt_get_in_touch}</h1>
                    <p className="third-design-heading-text">
                        {selectedLanguage?.txt_it_is_important_to_take_patient}
                    </p>
                    <div className="third-design-contact-information">
                        <div className="third-design-appointment-contact-information">
                            <div>
                                <div className="third-design-appointment-icon-div third-design-contact-icon-div">
                                    <button><FaCity /></button>
                                </div>
                                <div className="third-design-appointment-contact-text-div">
                                    <h2>
                                        {selectedLanguage?.txt_denpasar}
                                    </h2>
                                    <p>{selectedLanguage?.txt_jl_oberoi_x_69_kuta}</p>
                                </div>
                            </div>
                            <div>
                                <div className="third-design-appointment-icon-div third-design-contact-icon-div">
                                    <button><MdApartment /></button>
                                </div>
                                <div className="third-design-appointment-contact-text-div">
                                    <h2>{selectedLanguage?.txt_kuta}</h2>
                                    <p>support@domain.com</p>
                                </div>
                            </div>
                        </div>
                        <div className="third-design-appointment-contact-information">
                            <div>
                                <div className="third-design-appointment-icon-div third-design-contact-icon-div">
                                    <button><FiPhoneCall /></button>
                                </div>
                                <div className="third-design-appointment-contact-text-div">
                                    <h2>{selectedLanguage?.txt_call}</h2>
                                    <p>(+62)81 342 3471</p>
                                </div>
                            </div>
                            <div>
                                <div className="third-design-appointment-icon-div third-design-contact-icon-div">
                                    <button><GoMail /></button>
                                </div>
                                <div className="third-design-appointment-contact-text-div">
                                    <h2>{selectedLanguage?.txt_email_address}</h2>
                                    <p>support@domain.com</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="third-design-appointment-card-container third-design-appointment-screen-card-container">
                    <Form
                        labelCol={{ span: 24 }}
                        className='appointment-form'
                        name='form'
                        form={form}
                        onFinish={onFinish}
                        layout={'vertical'}
                        requiredMark={true}
                    >
                        <div className='third-design-appoint-form-div'>
                            <div>
                                <Form.Item
                                    className="third-design-appointment-div"
                                    name='name'
                                >
                                    <Input className="third-design-appointment-inputs  third-design-appointment-screen-inputs" placeholder={selectedLanguage?.name_label} />
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item
                                    className="third-design-appointment-div"
                                    name='email'
                                    rules={[
                                        {
                                            required: true,
                                            message: selectedLanguage?.txt_please_enter_your_email_message,
                                        },
                                        {
                                            type: 'email',
                                            message: selectedLanguage?.EmailIsNotValid,
                                        },
                                    ]}
                                >
                                    <Input className="third-design-appointment-inputs third-design-appointment-screen-inputs" placeholder={selectedLanguage?.input_email_placeholder} />
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item
                                    className="third-design-appointment-div"
                                    name='number'
                                >
                                    <Input type="number" className="third-design-appointment-inputs third-design-appointment-screen-inputs" placeholder={selectedLanguage?.input_number_placeholder} />
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item
                                    className="third-design-appointment-div"
                                    name='message'
                                >
                                    <Input.TextArea autoSize={{ minRows: 6 }} className="third-design-appointment-inputs third-design-appointment-screen-inputs" placeholder={selectedLanguage?.txt_your_message} />
                                </Form.Item>
                            </div>
                            <div className='third-design-appointment-form-btn-div third-design-appointment-form-btn-screen-div'>
                                <Form.Item
                                    wrapperCol={{ span: 24, offset: 0 }}
                                >
                                    <Button type="primary" htmlType="submit" loading={loading}>
                                        {selectedLanguage?.txt_send_message_}
                                    </Button>
                                </Form.Item>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
            <div className="contact-map-div">
                <Map />
            </div>
        </div>
    )
}

export default ThirdContact